import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '@/features/auth/LoginPage.tsx';

// ?redirect=/where-you-were — validated, and re-checked by safeRedirect() before use.
const searchSchema = z.object({ redirect: z.string().max(2_000).optional() });

export const Route = createFileRoute('/login')({
  validateSearch: searchSchema,
  component: LoginRoute,
});

function LoginRoute() {
  const { redirect } = Route.useSearch();
  return <LoginPage redirect={redirect} />;
}
